module.exports = __webpack_public_path__ + "img/remove.e0db4844.svg";